import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { imageUrlCheck } from "../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getBannerLoading } from "../../../Redux/BannerLoading/bannerLoadingSlice";

const SwiperItem = ({ data }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const user = useSelector((state) => state?.user?.value);
  const dispatch = useDispatch()
  const [imagURL, setImageURL] = useState(
    projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE
      ? projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE
      : require("../../../assets/Images/loading-landscape.gif")
  );
  const [isImageLoad, setIsImageLoad] = useState(false);

  const navigate = useNavigate();

  useEffect(()=>{
    return ()=>{
      dispatch(
        getBannerLoading({
          bannerLoading:false
        })
      )
    }
  },[])

  const playClickHandler = (item, options = {}) => {
    const { isSeeMore = false, showMoreInfo = false, isTrailer = false } = options;

    if (item?.type === "GENRE") {
      navigate(`/category/${item?.vanity_url}`);
      return;
    }

    if (item?.type === "SMART_HOME") {
      navigate(`/genre/${item?.vanity_url}`);
      return;
    }

    if (item?.type === "FASTCHANNEL") {
      const channelId = item?.channel_id || item?.uuid || item?.id || item?.show_id || item?.event_id || null;
      const stateObj = { channel_id: channelId, channelId: channelId, homelive: true };
      if (projectInfo?.projectConfig?.config?.MULTI_CHANNELS_REQUIRED === "true") {
        navigate(`/live-channels?c=${channelId}`, { state: stateObj });
      } else {
        navigate("/live");
      }
      return;
    }

    if (item?.type === "LIVE_EVENT" || item?.type === "UPCOMING_EVENT") {
      navigate(`/event/${item?.vanity_url ? item?.vanity_url : item?.event_id}`, {
        state: { showId: item?.event_id },
      });
      return;
    }

    if (item?.type === "VERTICAL_SHOW") {
      const showIdentifier = item?.vanity_url || item?.show_id;
      navigate(`/vertical-show/${showIdentifier}`, { state: { showId: item?.show_id } });
      return;
    }

    if (item?.show_id) {
      if (isTrailer && item?.teaser_vanity_url) {
        navigate(`/trailer/${item?.teaser_vanity_url}`, {
          state: { teaser_vanity_url: item.teaser_vanity_url },
        });
        return;
      }

      if (showMoreInfo) {
        navigate(`/show-details/${item?.vanity_url ? item?.vanity_url : item?.show_id}`, {
          state: {
            showId: item?.show_id,
            isSeeMore,
          },
        });
        return;
      } else if (item?.video_vanity_url) {
        navigate(`/videos/${item?.video_vanity_url}`, {
          state: {
            showId: item?.show_id,
            isSeeMore,
            videoDetails: item,
          },
        });
        return;
      } else {
        navigate(`/show-details/${item?.vanity_url ? item?.vanity_url : item?.show_id}`, {
          state: {
            showId: item?.show_id,
            isSeeMore,
          },
        });
        return;
      }
    } else if (item?.event_id) {
      navigate(`/event/${item?.vanity_url ? item?.vanity_url : item?.event_id}`, {
        state: { showId: item?.event_id },
      });
      return;
    } else if (item?.type === "VIDEO") {
      navigate(`/videos/${item?.vanity_url}`, {
        state: { videoDetails: item },
      });
      return;
    } else if (item?.teaser_vanity_url) {
      navigate(`/trailer/${item?.teaser_vanity_url}`, {
        state: { teaser_vanity_url: item.teaser_vanity_url },
      });
      return;
    }
  };
  
  const replaceImage = (error) => {
    error.target.src = projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE;
  };
  const afterImageLoad = (e) => {
    setIsImageLoad(true);
    dispatch(
      getBannerLoading({
        bannerLoading:true
      })
    )
    // let image;
    // if (imageUrlCheck(data?.banner) === true) {
    //   image = data?.banner;
    // } else {
    //   image = process.env.REACT_APP_IMAGE_URL + data?.banner;
    // }
    // setImageURL(image);
  };
  return (
    <div className={!isImageLoad?"bannerContainer loading":"bannerContainer"}>
      <div className="left">
        <div className="contents">
          <h1 className="title">{data?.show_name}</h1>
          {/* {data?.description && <p className="description">{data?.description}</p>} */}
          {data?.synopsis && <p className="description">{data?.synopsis}</p>}
          <span className="duration">{data?.duration_text}</span>
          <div className="buttonsWrapper">
            <div className="buttonContainer" onClick={() => playClickHandler(data)}>
              <div className={`background ${data.checkout_link ? "tvod" : ""}`}></div>
              <button>
                {data?.button_text && data.checkout_link ? data?.button_text : "Watch Now"}
              </button>
            </div>
            {data.show_trailer && <div className="buttonContainer" onClick={() => {playClickHandler(data, { isTrailer: true }) }}>
              <div className="Trailerbackground background"></div>
              <button>Trailer</button>
            </div>}
          </div>
        </div>
      </div>
      <div className="right">
        <div className="fadeGradient"></div>
        <div className={"imageContainer"}>
          {imageUrlCheck(data?.banner) ? (
            <img src={data?.banner} onError={(e) => replaceImage(e)} onLoad={(e) => afterImageLoad(e)} alt="BgImage" />
          ) : (
            <img src={`${process.env.REACT_APP_IMAGE_URL}${data?.banner}`} onError={(e) => replaceImage(e)} alt="BgImage"  />
          )}
          {/* <img src={imagURL} onError={(e) => replaceImage(e)} onLoad={(e) => afterImageLoad(e)} alt="BgImage" /> */}
          {/* <LazyLoadImage
            src={
              imagURL
            }
            effect="blur"
            alt="Image Alt"
            placeholderSrc={"https://miro.medium.com/max/882/1*9EBHIOzhE1XfMYoKz1JcsQ.gif"}
            onLoad={(e) => afterImageLoad()}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default SwiperItem;
